"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LAUNCHER_TYPE_DEFAULT = exports.DOM_INTERCEPT_TAGNAME = exports.DOM_NLQS_TAGNAME = exports.DOM_FPS_TAGNAME = exports.DOM_BPS_TAGNAME = exports.DOM_PSAT_TAGNAME = exports.DOM_NPS_TAGNAME = exports.DOM_FEEDBACKSURVEY_TAGNAME = exports.SurveyType = void 0;
var SurveyType;
(function (SurveyType) {
    SurveyType[SurveyType["Feedback"] = 0] = "Feedback";
    SurveyType[SurveyType["Nps"] = 1] = "Nps";
    SurveyType[SurveyType["Psat"] = 2] = "Psat";
    SurveyType[SurveyType["Bps"] = 3] = "Bps";
    SurveyType[SurveyType["Fps"] = 4] = "Fps";
    SurveyType[SurveyType["Nlqs"] = 5] = "Nlqs";
    SurveyType[SurveyType["Intercept"] = 6] = "Intercept";
    SurveyType[SurveyType["GenericMessagingSurface"] = 12] = "GenericMessagingSurface";
})(SurveyType = exports.SurveyType || (exports.SurveyType = {}));
exports.DOM_FEEDBACKSURVEY_TAGNAME = "FeedbackSurvey";
exports.DOM_NPS_TAGNAME = "Nps";
exports.DOM_PSAT_TAGNAME = "Psat";
exports.DOM_BPS_TAGNAME = "Bps";
exports.DOM_FPS_TAGNAME = "Fps";
exports.DOM_NLQS_TAGNAME = "Nlqs";
exports.DOM_INTERCEPT_TAGNAME = "Intercept";
exports.LAUNCHER_TYPE_DEFAULT = "survey";
